import React, { useContext, useEffect, useRef } from 'react';
import PrimaryButton from '../../Utilities/PrimaryButton/PrimaryButton';

import useAnalyticsEventTracker from '../../../GoogleAnalytics/useAnalyticsEventTracker';

import Carousel from 'react-multi-carousel';
import "react-multi-carousel/lib/styles.css";
import LoadingPage from '../../Utilities/LoadingPage/LoadingPage';

import Init from '../../../Init/Init';
import './WinvestDesktopHeader.scss';

import { buildWaLink, legalServiceLink, packageLink } from '../../../Util/Util';
import { connect } from 'react-redux';

let config = Init.config;
let { imageFolder, headerFolder, carousel } = config;

const mapStateToProps = (state) => {
    return {
        appRepo: state.appRepo.data
    }
}

const TemplateOne = ({ index, image, mascot, header, text, ctaButton, affirmation, displayButtonOnMobileView = false }) => {
    return (
        <div id={`winvest-desktop-header-${index}`} className="winvest-desktop-header">
            <div className={`winvest-desktop-header-content ${ index % 2 === 0 ? 'reversed' : '' }`}>
                <div className="winvest-desktop-header-title-container">
                    <h1 className='winvest-desktop-header-title' dangerouslySetInnerHTML={{__html: header}}>
                        
                    </h1>
                    <div className='winvest-desktop-header-tagline'> 
                        <span dangerouslySetInnerHTML={{__html: text.tagline}}>
                        </span>
                        {
                            text.whisper && (
                                <small>({ text.whisper })</small>
                            )
                        }
                    </div>
                    <div className="winvest-desktop-header-cta-button-container">
                        {
                            ctaButton.map( (item, index) => {
                                const buttonClick = item.hasOwnProperty('callback') ? item.callback : null;

                                return (
                                    <a key={index} target="_blank" href={ item.url } className='winvest-desktop-header-cta-button'>
                                        <img src={ item.image } alt="" />
                                    </a>
                                )
                            } )
                        }
                    </div>
                    <small className="notes" dangerouslySetInnerHTML={{__html: affirmation}}>
                    </small>
                </div>
                <div className="winvest-desktop-header-logo">
                    <img src={ image } alt="Waterfront Sekuritas Logo" />
                </div>
            </div>
        </div>
    );
}

const WinvestDesktopHeaderCarousel = (props) => {
    const { winvest } = Init.config.sectionAssets;

    let slider = [
        {
            /**
             * Background Image
             * Mascot
             * WinvestDesktopHeader
             * Text(Tagline, Whisper)
             * CTA Button
             * Affirmation: Working with PRP
             */
            image: `${ winvest.desktop }`,
            header: `
                <span class="inline-mobile">
                    <img src="${ winvest.desktopIcon }" />
                </span>
                <span class="inline-mobile">Trading Profesional dengan Aplikasi Winvest</span> 
            `,
            text: {
                tagline: `Nikmati Trading di Desktop Anda dengan Aplikasi Saham untuk MacOS dan Windows.`,
            },
            ctaButton: [
                {
                    image: `${ winvest.macos }`,
                    url: props.appRepo.length > 0 ? props.appRepo[2].download_url : "/",
                },
                {
                    image: `${ winvest.windows }`,
                    url: props.appRepo.length > 0 ? props.appRepo[2].download_url : "/",
                }
            ],
            displayButtonOnMobileView: true,
            // affirmation: `Bekerja sama dengan <span class='underline'>Pribadi Randa & Partners Law Firm</span>`,
            templateType: 1
        }, // 1
    ]

    /**
     * Carousels
     */
    let carouselConfig = carousel;

    carouselConfig.containerClass = "winvest-desktop-header-container";
    carouselConfig.itemClass = "winvest-desktop-header-item-holder";
    carouselConfig.autoPlay = false;
    carouselConfig.autoPlaySpeed = 5000;
    carouselConfig.showDots = false;
    carouselConfig.infinite = false;
    carouselConfig.responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1200 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1200, min: 900 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobileTablet: {
            breakpoint: { max: 900, min: 650 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 650, min: 0 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        }
    }

   return (
        <Carousel
            swipeable={carouselConfig.swipeable}
            draggable={carouselConfig.draggable}
            showDots={carouselConfig.showDots}
            responsive={carouselConfig.responsive}
            ssr={carouselConfig.ssr} // means to render carousel on server-side.
            infinite={carouselConfig.infinite}
            autoPlay={carouselConfig.autoPlay}
            autoPlaySpeed={carouselConfig.autoPlaySpeed}
            keyBoardControl={carouselConfig.keyBoardControl}
            transitionDuration={carouselConfig.transitionDuration}
            removeArrowOnDeviceType={carouselConfig.removeArrowOnDeviceType}
            deviceType={carouselConfig.deviceType}
            containerClass={carouselConfig.containerClass}
            dotListClass={carouselConfig.dotListClass}
            itemClass={carouselConfig.itemClass}
            centerMode={carouselConfig.centerMode}
        >
            {
                slider.length > 0 ? (
                    slider.map((v, k) => {
                        return <TemplateOne 
                            key={k} 
                            index={k} 
                            image={ v.image }
                            mascot={ v.mascot }
                            header={ v.header }
                            text={ v.text }
                            ctaButton={ v.ctaButton }
                            affirmation={ v.affirmation }
                            displayButtonOnMobileView={ v.displayButtonOnMobileView }
                        />
                    })
                ) : (
                    <LoadingPage />
                )
            }
        </Carousel>
    );
}

const WinvestDesktopHeader = (props) => {
    return <WinvestDesktopHeaderCarousel appRepo={ props.appRepo } />
}



export default connect(mapStateToProps)(WinvestDesktopHeader);